import { POST, PUT, SUCCESS } from "../utils/const/http-const";
import { BASE_URL } from "../utils/const/base-url";
import { getHeaders } from "./utils";
import moment from "moment";

export async function createApplicant(obj) {
  try {
    let data = { error: true };
    const { code, body, message } = await fetch(
      `${BASE_URL}/applicant/save-applicant`,
      {
        headers: getHeaders(false),
        method: POST,
        body: JSON.stringify(obj),
      }
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      data.error = false;
      data.body = body;
    } else {
      data.error = true;
      data.message = message;
      data.body = null;
    }
    // console.log('data');
    // console.log(data);
    return data;
  } catch (err) {
    console.log("createApplicant err");
    console.log(err);
    return { error: true };
  }
}

export async function getListApplicant(obj, t) {
  try {
    let data = { error: true };
    const { code, body, message } = await fetch(
      `${BASE_URL}/applicant/get-applicant`,
      {
        headers: getHeaders(),
        method: POST,
        body: JSON.stringify(obj),
      }
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      data.error = false;
      data.body = body;

      for (let i = 0; i < data.body.length; i++) {
        data.body[i].enableLabel = data.body[i].enable === 1 ? t('column_enable_yes') : t('column_enable_no');
        data.body[i].dateProcess = moment(data.body[i].dateProcess).format("MM/DD/YYYY HH:mm");
      }


    } else {
      data.error = true;
      data.message = message;
      data.body = null;
    }
    // console.log('data');
    // console.log(data);
    return data;
  } catch (err) {
    console.log("getListApplicant err");
    console.log(err);
    return { error: true };
  }
}

export async function modifyApplicant(obj) {
  try {
    let data = { error: true };
    const { code, body, message } = await fetch(
      `${BASE_URL}/applicant/modify-applicant`,
      {
        headers: getHeaders(),
        method: PUT,
        body: JSON.stringify(obj),
      }
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      data.error = false;
      data.body = body;
    } else {
      data.error = true;
      data.message = message;
      data.body = null;
    }
    // console.log('data');
    // console.log(data);
    return data;
  } catch (err) {
    console.log("modifyApplicant err");
    console.log(err);
    return { error: true };
  }
}

export async function disableApplicant(obj) {
  try {
    let data = { error: true };
    const { code, body, message } = await fetch(
      `${BASE_URL}/applicant/disable-applicant`,
      {
        headers: getHeaders(),
        method: PUT,
        body: JSON.stringify(obj),
      }
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      data.error = false;
      data.body = body;
    } else {
      data.error = true;
      data.message = message;
      data.body = null;
    }
    // console.log('data');
    // console.log(data);
    return data;
  } catch (err) {
    console.log("disableApplicant err");
    console.log(err);
    return { error: true };
  }
}

export async function enableApplicant(obj) {
  try {
    let data = { error: true };
    const { code, body, message } = await fetch(
      `${BASE_URL}/applicant/enable-applicant`,
      {
        headers: getHeaders(),
        method: PUT,
        body: JSON.stringify(obj),
      }
    ).then((res) => res.json());
    // console.log('code');
    // console.log(code);
    // console.log('body');
    // console.log(body);
    if (code === SUCCESS) {
      data.error = false;
      data.body = body;
    } else {
      data.error = true;
      data.message = message;
      data.body = null;
    }
    // console.log('data');
    // console.log(data);
    return data;
  } catch (err) {
    console.log("enableApplicant err");
    console.log(err);
    return { error: true };
  }
}